// extracted by css-extract-rspack-plugin
export default {"container":"_92587d9a","collection":"_dc39fbab","tile":"_e2246f89","tileTitle":"_e1d44fc9"};